import { useNavigate } from 'react-router-dom';
import AlbumForm from '@/components/feature/AlbumForm';
import { createAlbum } from '@/services/albumService';

export default function AlbumCreatePage() {
  const navigate = useNavigate();

  const handleSubmit = async (data: { title: string; description: string; coverImage: string }) => {
    await createAlbum(data);
    navigate('/albums');
  };

  const handleCancel = () => {
    navigate('/albums');
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header className="sticky top-0 z-20 bg-background-50/95 backdrop-blur-sm border-b border-background-200/50">
        <div className="flex items-center gap-3 px-4 py-3">
          <button
            onClick={handleCancel}
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-secondary-100 transition-colors cursor-pointer flex-shrink-0"
            aria-label="뒤로 가기"
          >
            <i className="ri-arrow-left-line text-xl text-foreground-700"></i>
          </button>
          <h1 className="text-base font-bold text-foreground-950">새 앨범 만들기</h1>
        </div>
      </header>

      {/* Form */}
      <section className="px-4 py-6">
        <AlbumForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitLabel="만들기"
        />
      </section>
    </div>
  );
}